export default {
	ejari_handover_request: {
		en: "Ejari Handover Request",
		ar: "طلب تسليم إيجاري",
	},
	ejari_takeover_request: {
		en: "Ejari Takeover Request",
		ar: "طلب استلام إيجاري"
	},
	contract_parties_information: {
		en: "Contract Parties Information",
		ar: "معلومات أطراف العقد",
	},
	ejari_handover: {
		en: "Ejari Handover",
		ar: "تسليم إيجاري",
	},
	ejari_takeover: {
		en: "Ejari Takeover",
		ar: "استلام إيجاري",
	},
	ejari_contract_number: {
		en: "Ejari Contract Number",
		ar: "رقم عقد ايجاري",
	},
	landlord_lessor: {
		en: "Landlord / Lessor",
		ar: "المالك / المؤجّر",
	},
	landlord_name: {
		en: "Landlord / Lessor Name",
		ar: "اسم المالك / المؤجّر",
	},
	landlord_eid: {
		en: "Landlord / Lessor Emirates ID",
		ar: "رقم هوية المالك / المؤجّر",
	},
	tenant_emirates_id: {
		en: "Tenant Emirates ID",
		ar: "رقم هوية المستأجر",
	},
	property_status_at_time_handover: {
		en: "Property Status at the time of Handover",
		ar: "حالة العقار عند التسليم",
	},
	property_status_at_time_takeover: {
		en: "Property status at the time of Takeover",
		ar: "حالة العقار عند الاستلام"
	},
	description: {
		en: "Description",
		ar: "الوصف",
	},
	current_status_property: {
		en: "Current status of property",
		ar: "الوضع الحالي للعقار / حالة العقار في الوقت الراهن",
	},
	property_key_qty: {
		en: "No. of property keys",
		ar: "عدد مفاتيح العقار",
	},
	parking_entrance_cards: {
		en: "No. of building / parking entrance cards/keys",
		ar: "عدد مفاتيح / بطاقات دخول المواقف / البناية",
	},
	security_deposit_amount: {
		en: "Security Deposit Amount",
		ar: "قيمة التأمين المدفوع",
	},
	finalize_requirements: {
		en: "Finalized Requirements",
		ar: "المتطلبات النهائية",
	},
	any_damage_property: {
		en: "Any Damages to the Property?",
		ar: "هل توجد أي أضرار في العقار؟",
	},
	provide_description: {
		en: "Provide description",
		ar: "ضع وصفاً / قدّم وصفاً / الوصف المتاح",
	},
	save_as_draft: {
		en: "Save as Draft",
		ar: "حفظ كمسودة",
	},
	request_type: {
		en: "Request Type",
		ar: "نوع الطلب",
	},
	handover_takeover_requests: {
		en: "Ejari Handover / Takeover Requests",
		ar: "طلبات تسليم / استلام إيجاري",
	},
	requests_from_owner: {
		en: "Requests from Owner",
		ar: "طلبات من المالك",
	},
	ht_draft_success: {
		en: "Your request for ~ saved as draft. You can track the status of your request via \"My Requests\".",
		ar: "تم حفظ طلبك ~ كمسودة. بإمكانك تتبع حالة الطلب عبر \"طلباتي\".",
	},
	ht_submit_success: {
		en: "Your request for ~ has been sent to the tenant for approval. You can track the status of your request via \"My Requests\".",
		ar: "تم إرسال طلبك ~ إلى المستأجر للموافقة عليه. بإمكانك تتبع حالة الطلب عبر \"طلباتي\".",
	},
	ht_accept_success: {
		en: "Request for ~ has been approved. You can track the status of your request via \"Requests from Owner\" option.",
		ar: "تم الموافقة على طلبك ~ . بإمكانك تتبع حالة الطلب عبر الخيار \"طلب من المالك\"."
	},
	ht_rejected_success: {
		en: "Request for ~ has been rejected. You can track the status of your request via \"Requests from Owner\" option.",
		ar: "تم رفض طلبك ~ . بإمكانك تتبع حالة الطلب عبر الخيار \"طلب من المالك\"."
	},
	ht_total_file_size_note: {
		en: "Note: Total file size allowed is ~ MB. Allowed files type are .jpg, .png and .pdf",
		ar: "ملاحظة: الحجم الإجمالي للملف المسموح به هو ~ ميغا بايت. أنواع الملفات المسموح بها هي jpg، png، pdf",
	},
	ht_error_total_file_size: {
		en: "Total file size allowed is exceeded.",
		ar: "الحجم الإجمالي للملف تجاوز الحدّ المسموح به.",
	},
	rejection_details: {
		en: "Rejection Details",
		ar: "تفاصيل الرفض",
	},
	reasons_comments: {
		en: "Reasons & Comments",
		ar: "الأسباب & تعليقات",
	},
	disclaimer_tenant_accept: {
		en: "I declare that the information provided by landlord on the above forms is true and correct to the best of my knowledge.",
		ar: "أقر بأن المعلومات التي قدمها المالك في النماذج المذكورة أعلاه حقيقية وصحيحة على حد علمي.",
	},
	property_status_at_time_handover_info: {
		en: "Furnished – Furnished with sofa, bedroom & kitchen appliances, etc.\n" +
			"Fitted – Wardrobes, Kitchen cupboards, etc.\n" +
			"Not Fitted – Shell & Core.",
		ar: "مفروشة - مفروشة بأريكة وغرفة نوم وأدوات مطبخ، إلخ.\n" +
			"مجهّزة – خزائن ملابس، خزائن مطبخ، إلخ.\n" +
			"غير مجهّزة – البناء الأساسي / البناء عظم / الهيكل الأساسي."
	},
	agree: {
		en: "Agree",
		ar: "يوافق على",
	},
};
